import React, { createContext, useContext, useRef, useState } from 'react';

export enum PrefillStep {
  LetsGetStarted,
  Verification,
  AccountStatus,
}

type ProveState = {
  optInPrefill: React.MutableRefObject<boolean>;
  step: PrefillStep;
  setStep: (value: PrefillStep) => void;
};

const ProveContext = createContext<ProveState | null>(null);

export default function ProveContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const optInPrefill = useRef(false);
  const [step, setStep] = useState(PrefillStep.LetsGetStarted);

  return (
    <ProveContext.Provider value={{ optInPrefill, step, setStep }}>
      {children}
    </ProveContext.Provider>
  );
}

export function useProveContext() {
  const context = useContext(ProveContext);
  if (context === null) {
    throw new Error(
      'useProveContext must be used within a ProveContextProvider'
    );
  }
  return context;
}
